<template>

  <div class="container-fluid mt-4 dfe-container">
    <Breadcrumb :breadcrumbs="breadcrumbs"/>

    <keep-alive v-if="isEnabled && $withPolicy('dfe', 'viewer')">
      <router-view/>
    </keep-alive>
    <div v-else>
      <h1>Aplicativo não habilitado</h1>
    </div>

  </div>

</template>

<script>
  import Breadcrumb from '@/components/shares/Breadcrumb'
  import BreadcrumbMixin from '@/mixins/BreadcrumbMixin'
  import GetAccountApps from '@/mixins/GetAccountApps'

  export default {
    components: { Breadcrumb },
    computed: {
      isEnabled() {
        return this.activeAccountApps.some(aa => aa.name === 'dfe')
      }
    },
    mixins: [BreadcrumbMixin, GetAccountApps],
    name: 'DFe'
  }
</script>

<style scoped>
  .dfe-container {
    height: calc(100% -  1.5rem);
  }
</style>
